import React from 'react';

const ProposalLoadingPopup = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm flex items-center justify-center font-outfit">
      <div className="bg-white rounded-xl border border-black/20 shadow-[4px_17px_68px_3px_rgba(0,0,0,0.11),58px_267px_109px_0_rgba(0,0,0,0.01),90px_417px_119px_0_rgba(0,0,0,0.00)] w-[500px] px-8 py-6">
        {/* Lottie Animation via iframe */}
        <div className="flex justify-center mb-4">
          <iframe 
            src="https://lottie.host/embed/2417db5e-bad4-4e3b-b45c-40e9ed349c65/XxbqXykFQz.lottie"
            className="w-36 h-36 rounded-md"
            title="Loading Animation"
          />
        </div>
        
        {/* Title */}
        <h3 className="text-2xl font-semibold text-[#171717] mb-3 text-center">
          Creating Proposal
        </h3>
        
        {/* Message */}
        <p className="text-base font-normal text-[#52525B] leading-relaxed text-center">
        Please wait while we generate your proposal document...
        </p>

        {/* Single Progress Bar */}

      </div>
    </div>
  );
};

export default ProposalLoadingPopup;
